export default {
    DISABLE_CHAT_INPUT_FIELD: 'DISABLE_CHAT_INPUT',
    END_CHAT_FIELD: 'END_CHAT',
    FORM_URL: 'FORM_URL',
    FORM_ID: 'FORM_ID',
    FORMID: 'FORMID',
    CALLBACK_EVENT: 'CALLBACK_EVENT',
    CALLBACKEVENT: 'CALLBACKEVENT',
    FORM_SCHEMA: 'FORM_SCHEMA',
    PRIMARY_LANGUAGE: 'PRIMARY_LANGUAGE'
}